import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ChapterIntroRow from "@/components/ChapterIntroRow";

export default function ChapterIntrosAdmin() {
  const [intros, setIntros] = useState(null);

  useEffect(() => {
    api.get("/admin/chapter-intros").then((r) => setIntros(r.data.intros)).catch(() => {});
  }, []);

  if (!intros) return null;
  const replace = (next) => setIntros((list) => list.map((i) => (i.section_id === next.section_id ? next : i)));

  return (
    <section className="border border-obsidian-600 p-6 mb-10" data-testid="chapter-intros-admin">
      <h2 className="font-serif text-2xl text-bone-100 mb-2">Chapter intros in your voice</h2>
      <p className="font-sans text-sm text-bone-400 mb-2">
        A ~15-second word from you with a play button at the start of each chapter (Chapter One's also plays on /try). Edit the
        draft script and record it with your ElevenLabs voice, or upload your own take. Hidden until recorded.
      </p>
      <p className="font-sans text-xs text-bone-500 mb-3" data-testid="chapter-intros-count">
        {intros.filter((i) => i.available).length} of {intros.length} recorded
      </p>
      {intros.map((i) => <ChapterIntroRow key={i.section_id} intro={i} onSaved={replace} />)}
    </section>
  );
}
